import React from 'react';
import { Box, TextField, MenuItem } from '@mui/material';
import { BlockSettingsProps } from './types';

export const KedoChartsSettings: React.FC<BlockSettingsProps> = ({
    kedo,
    state,
    handleChangeSettings,
}) => {
    return (
        <Box sx={{ mt: 2 }}>
            <TextField
                select
                size="small"
                fullWidth
                label={kedo.t('Chart type')}
                value={state.item.settings.chart_layout || ''}
                onChange={(e) => handleChangeSettings('chart_layout', e.target.value)}
                margin="normal"
            >
                <MenuItem value="">
                    {kedo.t('Choose an option')}
                </MenuItem>
                <MenuItem value="chart">{kedo.t('Chart')}</MenuItem>
                <MenuItem value="dashboard">{kedo.t('Dashboard')}</MenuItem>
            </TextField>
            <TextField
                size="small"
                fullWidth
                label={kedo.t('Identifier')}
                value={state.item.settings.chart_identifier || ''}
                onChange={(e) => handleChangeSettings('chart_identifier', e.target.value)}
                margin="normal"
            />
        </Box>
    );
};